import React from 'react';
import './../theme/layout_orange.css';
import zh_TW from 'antd/es/locale/zh_TW';
import { ConfigProvider } from 'antd';
import RouteOfficeWeb from './../components/DemoWms/RouteOfficeWeb';
const Demosite = () => {
    // const onChangeLanguage = (value) => {
    //     const localeValue = value;
    //     setLocal(localeValue);
    //     console.log(value)
    // }
    // const [locale, setLocal] = useState(zh_TW);
    
    return (<>
        <ConfigProvider
            locale={zh_TW}
            theme={{
                token: {
                    //橘色
                    colorPrimary: '#fa8c16',
                    fontSize: 16
                },
            }}>
            <RouteOfficeWeb />
        </ConfigProvider>
    </>)
}
export default Demosite;
